import React from 'react';
import {
  StepTitle,
  ErrorBold,
  ErrorListItem,
  ContentContain,
  StepInformation,
  ErrorListContain
} from './CreateStyled';

import Card from 'components/common/Card';

export const CriticalError = ({ renderActions }) => (
  <Card.Content>
    <ContentContain>
      <StepTitle>Order Error</StepTitle>
      <StepInformation as="div">
        An error has occurred that will prevent the order from being processed
        correctly. This may be due the follow reasons:
        <ErrorListContain>
          <ErrorListItem>
            <ErrorBold>Internet Connectivity</ErrorBold>
            <br /> Please check that you are still connected to the internet and try
            again.
          </ErrorListItem>
          <ErrorListItem>
            <ErrorBold>Server Issues</ErrorBold>
            <br />
            We may be experiencing technical difficulties on our end. If so please
            try again later.
          </ErrorListItem>
        </ErrorListContain>
      </StepInformation>
    </ContentContain>
    {renderActions({ reset: true, backLabel: 'Restart', disableNext: true })}
  </Card.Content>
);

export default CriticalError;
